import { Stack, Typography } from '@mui/material'
import { type SurveyElement } from '../MidYearSummary'
import { FileDownloadCard } from './FileDownloadCard'
import { SURVEY_FILE_KEY_SUFFIX, SURVEY_FILE_SUFFIX } from '../../../../../../../constants/surveyConstants'

interface Props {
  element: SurveyElement
  answers: Record<string, any>
}
export const SummaryFileUpload = ({ element, answers }: Props): JSX.Element => {
  const fileName = answers[element.name + SURVEY_FILE_SUFFIX]
  const fileKey = answers[element.name + SURVEY_FILE_KEY_SUFFIX]

  return (
    <Stack gap={1}>
      <Typography variant='body1'>{element.title}</Typography>
      {fileName != null && fileKey != null
        ? <FileDownloadCard fileName={fileName} fileKey={fileKey} />
        : <Typography variant='body1' color='text.disabled'>No file uploaded</Typography>
      }
    </Stack>
  )
}
